import React from "react";
// import Navbar from "../components/Navbar";
import HeroSection from "../Component/Herosection";
import OurStory from "../Component/Ourstory";
import Count from "../Component/Count";
import Card from "../Component/Card";
import ClientTestimonial from "../Component/ClientTestimonial";


const About = () => {
    return (
     <>
      
      <HeroSection/>
      <OurStory/>
      {/* <Statsection/> */}
      <div className="bg-[#0F172B]">
        <Count/>
      </div>
      <Card/>
      {/* <Certificate/> */}
      <ClientTestimonial/>
  </>
      
    );
  };
  
  export default About;
  